// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AccountMenuButton-cls1__c3c5eba5086fbca935bf{/*!*/}.AccountMenuButton-cls2___388eb8ca16a10571e18{width:20px;height:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AccountMenuButton-cls1__c3c5eba5086fbca935bf",
	"cls2": "AccountMenuButton-cls2___388eb8ca16a10571e18 AccountMenuButton-cls1__c3c5eba5086fbca935bf"
};
export default ___CSS_LOADER_EXPORT___;
